export default __webpack_public_path__ + "static/media/012-blood-transfusion.457fdbfd.png";